/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useContext } from 'react';

// Context
import { WorkspaceLayoutContext } from '@layouts/WorkspaceLayout/context';

// Types
import { CurrentWorkspace } from '@layouts/WorkspaceLayout/types';

/* -------------------------------------------------------------------------- */
/*                                    Hook                                    */
/* -------------------------------------------------------------------------- */

/**
 * Returns current workspace from context
 * @returns {CurrentWorkspace} Current workspace
 */
function useWorkspace(): CurrentWorkspace {
  const { workspace } = useContext(WorkspaceLayoutContext);

  if (!workspace) {
    throw new Error('useWorkspace must be used within WorkspaceLayoutProvider');
  }

  return workspace;
}

export default useWorkspace;
